import { render, staticRenderFns } from "./TimeToMarketTable.vue?vue&type=template&id=21c03506&scoped=true&"
import script from "./TimeToMarketTable.vue?vue&type=script&lang=js&"
export * from "./TimeToMarketTable.vue?vue&type=script&lang=js&"
import style0 from "./TimeToMarketTable.vue?vue&type=style&index=0&id=21c03506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c03506",
  null
  
)

export default component.exports